import React from 'react'
import { useTheme } from '../../context/ThemeContext'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useAssetsCards } from '../../Hooks/Features/InventoryDashboard/useAssetsCards';

const AssetsCards = ({ cardSummary }) => {

    const { theme } = useTheme();
    const { getIcon } = useAssetsCards();

    return (
        <div className="row">
            {cardSummary?.map((item, index) => {
                const icon = getIcon(item?.card_name);
                return (
                    <div className='col-lg-2 col-md-4 col-6 p-2' key={index} >
                        <div className='py-2 px-3 rounded border' style={{ backgroundColor: theme === "dark" ? "#000" : "#ffff" }}>
                            <div className="d-flex align-items-center gap-4 py-1" >
                                <div className='rounded py-1 px-2' style={{ background: icon?.backgroundColor, fontSize: "16px" }}>
                                    <FontAwesomeIcon icon={icon?.icon} style={{ color: icon?.color || "black" }} />
                                </div>
                                <div className="w90">
                                    <div className="text-truncate w100" style={{ color: "grey", fontSize: "0.75rem" }}>{item?.card_name}</div>
                                    <div className="fw-bold fs-5">{item?.total_counts}</div>
                                </div>
                            </div>
                            <div className='d-flex justify-content-between border-top py-2' style={{ fontSize: "12px", fontWeight: "500" }}>
                                <span className='text-success'>{item.available} Available</span>
                                <span className='text-primary'>{item.assigned} Assigned</span>
                            </div>
                        </div>
                    </div>
                )
            })}
        </div>
    )
}

export default AssetsCards
